import { cn } from '../../lib/utils';
import type { ContentActionsProps } from './types';

// Labelled commands act on the page's data, so they belong to the content, not
// to the chrome — the title row takes an icon-only control and nothing else.
// Right-aligned at the top of the content region, or on the section nav row
// where a page has one.
export function ContentActions({ children, className }: ContentActionsProps) {
  return (
    <div
      data-testid="content-actions"
      className={cn('flex flex-wrap items-center justify-end gap-3', className)}
    >
      {children}
    </div>
  );
}
